<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 ml-auto mr-auto text-center">
        <h1 class="my-1 pt-4">
          Aller plus loin avec la version Pro<i
            class="ml-3 tim-icons icon-spaceship"
          ></i>
        </h1>
        <h4 class="text-primary mb-5"></h4>
      </div>
    </div>
    <div class="row mx-auto">
      <div class="col-md-4 offset-md-2">
        <card
          type="pricing"
          class="card-primary"
          footer-classes="text-center mb-3 mt-3"
        >
          <h1 class="card-title">pro</h1>
          <img class="card-img" src="img/card-primary.png" alt="Image" />
          <ul class="list-group">
            <li class="list-group-item">Stockage avancé</li>
            <li class="list-group-item">Création de Watchlist</li>
            <li class="list-group-item">Historique des positions</li>
            <li class="list-group-item">Prise de notes</li>
            <li class="list-group-item">
              Stockage des AT
              <el-tooltip
                :content="
                  'Vos analyses graphiques sur chaque instruments sont sauvegardées.'
                "
                effect="light"
                :open-delay="100"
                placement="top"
              >
                <i class="fas fa-info-circle"></i>
              </el-tooltip>
            </li>
          </ul>
          <div class="card-prices my-3">
            <h3 class="text-on-front">5€/mois</h3>
            <h5 class="text-on-back">5€</h5>
            <p class="plan">Formule pro</p>
          </div>
        </card>
      </div>
      <div class="col-md-4 text-center mt-3" v-if="!conf.isPro">
        <h4>
          <span class="text-primary">
            Envie de débloquer toutes les fonctionnalités de Moni ?
          </span>
          <br /><br />
          Vous bénéficierez de plus de stockage et de l'ensemble des
          fonctionnalités actuelles et à venir.
        </h4>

        <div>
          <span
            @click="getPro()"
            class="mt-3 text-center btn btn-primary btn-simple"
          >
            Passer pro
          </span>
        </div>

        <div class="text-muted mt-5">
          <small>
            La formule basique offre un stockage de 60 jours de performances
            journalières et 1 an de performances hebdo.
          </small>
          <br />
          <small>
            La formule pro offre un stockage de 365 jours de performances
            journalières et 4 ans de performances hebdo.
          </small>
        </div>
      </div>
      <div class="col-md-4 text-center mt-3" v-if="conf.isPro">
        <h4>
          <span class="text-primary">Vous avez la formule Pro !</span>
          <br /><br />
          Vous bénéficiez de toutes les fonctionnalités actuelles de Moni et
          celles à venir.
        </h4>

        <div>
          <span
            @click="updateSubscription()"
            class="mt-3 text-center btn btn-primary btn-simple"
          >
            Modifier mon abonnement
          </span>
        </div>

        <div class="text-muted mt-5">
          <small>
            La formule basique offre un stockage de 60 jours de performances
            journalières et 1 an de performances hebdo.
          </small>
          <br /><br />
          <small>
            La formule pro offre un stockage de 365 jours de performances
            journalières et 4 ans de performances hebdo.
          </small>
        </div>
      </div>
    </div>

    <!-- <div class="row justify-content-center my-3 pt-3">
      <div class="col-md-6 text-center my-2">
        <div class="icon icon-primary mb-3" style="font-size: 3em">
          <i class="tim-icons icon-gift-2"></i>
        </div>
        <div class="description">
          <h3 class="info-title">5€, pour quoi faire ?</h3>
          <p class="description">
            Moni est conçu pour limiter l'usage intensif de système cloud et
            réduire ainsi son impact environnemental, nous avons toutefois des
            frais de fonctionnement cloud et des licences à payer pour accéder
            aux données de marchés. L'offre payante nous donne un coup de pouce
            pour faire perdurer le projet.
          </p>
        </div>
      </div>
      <div class="col-md-6 text-center my-2">
        <div class="icon icon-warning mb-3" style="font-size: 3em">
          <i class="tim-icons icon-satisfied"></i>
        </div>
        <div class="description">
          <h3 class="info-title">Don associatif</h3>
          <p class="description">
            Si le projet génère des bénéfices, ceux-ci seront redistribués à
            différentes associations.
            <br />
            Les chiffres et informations relatives aux dons seront communiqués
            en toute transparence sur le compte
            <a
              href="https://twitter.com/moni_app"
              class="text-primary font-weight-bold"
              >Twitter</a
            >.
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { activatePro, openStripeDashboard } from "../../dao/firestore";

export default {
  components: {},
  computed: {
    ...mapGetters({
      conf: "auth/conf",
      user: "auth/user"
    })
  },
  data() {
    return {
      nextDate: new Date(),
      donationForm: false,
      assoName: "Les Petits Princes",
      donationValue: null
    };
  },
  methods: {
    getPro() {
      this.$swal(
        "C'est parti !",
        "Vous allez être redirigé vers notre partenaire de paiement Stripe",
        "success"
      );
      activatePro(this.user);
    },
    updateSubscription() {
      this.$swal(
        "C'est parti !",
        "Vous allez être redirigé vers notre partenaire de paiement Stripe",
        "success"
      );
      openStripeDashboard();
    }
  },
  mounted() {
    if (this.$route.query.success) {
      this.$swal(
        "C'est bon !",
        "Vous bénéficiez de toutes les fonctionnalités de moni :)",
        "success"
      );
    } else if (this.$route.query.cancel) {
      this.$swal(
        "Oups !",
        "Vous n'avez pas le mode pro, pas de soucis ! Moni offre déjà tout un tas de fonctionnalités dans son mode gratuit :)",
        "error"
      );
    }
  },
  metaInfo() {
    return {
      title: "Get Peamoni Pro"
    };
  }
};
</script>
<style></style>
